import { Text } from '@elements/text';
import { TextWithMd } from '@elements/text/textWithMd';
import { i18n } from '@i18n';

export function ExcessModal() {
  return (
    <div className="text-left gap-s8 flex flex-col">
      <Text variant="h4-24/sb">{i18n.t('myQuote.excess.title')}</Text>
      <TextWithMd variant="body-16/r">{i18n.t('boostShared.excess.modal.content')}</TextWithMd>
    </div>
  );
}
